module.exports = __webpack_public_path__ + "assets/img/12_37_big.5e8920b3.jpg";